import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { LOGO_URL } from "@/lib/api";

export default function LoadingScreen() {
  const [show, setShow] = useState(true);
  useEffect(() => {
    const t = setTimeout(() => setShow(false), 1200);
    return () => clearTimeout(t);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6, ease: "easeInOut" }}
          className="loader-veil"
          data-testid="luxury-loader"
        >
          <motion.img
            initial={{ scale: 0.85, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.7, ease: [0.2, 0.7, 0.2, 1] }}
            src={LOGO_URL}
            alt="Blisson Professional"
            className="h-28 md:h-36 w-auto object-contain mix-blend-multiply"
            data-testid="loader-logo"
          />
          <div className="w-32 h-[2px] mt-10 overflow-hidden bg-black/5">
            <div className="h-full w-full gold-shimmer" />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
